import { makeStyles } from '@mui/styles';

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: '100vw',
    width: '100vw',
    minHeight: '100vh',
    height: '100vh',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  activeItem: {
    backgroundColor: '#595959',
    '&:hover': {
      backgroundColor: '#656565',
    },
    '& svg': {
      color: '#FFF',
    },
    '& div': {
      fontWeight: '300',
    },
  },
}));

export default useStyle;
